/**
 * Media processing result returned by the backend (Module 12).
 *
 * This mirrors `AgentOps.Application.Features.MultiModal.DTOs.MediaProcessingResult`.
 */
export interface MediaProcessingResult {
  mediaType: string;
  status: 'Pending' | 'Processing' | 'Completed' | 'Failed' | 'Skipped';
  extractedText?: string | null;
  transcription?: string | null;
  caption?: string | null;
  description?: string | null;
  metadata?: Record<string, any>;
  errorMessage?: string | null;
}

/**
 * Best-effort parser for processed content JSON.
 */
export const tryParseMediaProcessingResult = (json?: string | null): MediaProcessingResult | undefined => {
  if (!json) return undefined;
  try {
    return JSON.parse(json) as MediaProcessingResult;
  } catch {
    return undefined;
  }
};

